export const SAVE_DISPLAYED_RETURN_REASONS = 'SAVE_DISPLAYED_RETURN_REASONS';
export const SAVE_SELECTED_RETURN_REASON = 'SAVE_SELECTED_RETURN_REASON';
export const SAVE_NESTED_DISPLAYED_RETURN_REASONS = 'SAVE_NESTED_DISPLAYED_RETURN_REASONS';
export const SAVE_SELECTED_NESTED_RETURN_REASON = 'SAVE_SELECTED_NESTED_RETURN_REASON';

export const getParentReasonId = (reason) => {
  const id =
    reason.return_reasons &&
    reason.return_reasons.length === 1 &&
    reason.return_reasons[0].return_reason_code_id;
  return id || null;
};

export const saveDisplayedReturnReasons = (reasons = []) => {
  const formatted = reasons.map((reason) => ({
    id: getParentReasonId(reason),
    name: reason.reason_category,
  }));
  return {
    type: SAVE_DISPLAYED_RETURN_REASONS,
    data: { displayedReturnReasons: formatted },
  };
};

export const saveNestedDisplayedReturnReasons = (returnReasons) => {
  const reasons = returnReasons || [];
  const formatted = reasons.map((reason) => {
    const { return_reason_code_id: id, display_name: name } = reason;
    return { id, name };
  });
  return {
    type: SAVE_NESTED_DISPLAYED_RETURN_REASONS,
    data: { nestedDisplayedReturnReasons: formatted },
  };
};

export const saveSelectedReturnReason = (reason) => ({
  type: SAVE_SELECTED_RETURN_REASON,
  data: {
    selectedReturnReason: { id: getParentReasonId(reason), name: reason.reason_category },
  },
});

export const saveSelectedNestedReturnReason = ({
  return_reason_code_id: id,
  display_name: name,
}) => ({
  type: SAVE_SELECTED_NESTED_RETURN_REASON,
  data: { selectedNestedReturnReason: { id, name } },
});

export const receiveSelectedReturnReason = ({ id, name }) => ({
  type: SAVE_SELECTED_RETURN_REASON,
  data: {
    selectedReturnReason: {
      id,
      name,
    },
  },
});
